import * as S from "./styles";

import { ReactComponent as CloseIcon } from "assets/close-small.svg";
import { ReactComponent as Arrow } from "assets/Dashboard/left.svg";
import { ReactComponent as Download } from "assets/download.svg";
import { fireToast } from "services/sweetAlertConfig";

type Coordinate = {
  lat: number | string;
  lng: number | string;
};

type GalleryPictureProps = {
  imgUrl: string;
  imgAlt: string;
  isOpen: boolean;
  coord?: string;
  onCloseButtonClick: () => void;
  galleryLength: number;
  selectedGalleryPictureIndex: number;
  onLeftArrowClick: () => void;
  onRightArrowClick: () => void;
};

export default function GalleryPicture({
  imgUrl,
  isOpen,
  imgAlt,
  coord,
  onCloseButtonClick,
  galleryLength,
  selectedGalleryPictureIndex,
  onLeftArrowClick,
  onRightArrowClick,
}: GalleryPictureProps) {
  if (!isOpen) return null;

  function treatCoordinates(): Coordinate | null {
    if (!coord) return null;
    const [lat, lng] = coord.split(",").map((item) => item.trim());
    return { lat, lng };
  }

  const coordinates = treatCoordinates();

  function handleCopyCoordinates(coordinates: Coordinate) {
    const coordinateString = `${coordinates.lat}, ${coordinates.lng}`;
    navigator.clipboard.writeText(coordinateString);
    fireToast("Coordenadas copiadas com sucesso", 3000, "top-end");
  }

  function handleDownload() {
    window.open(imgUrl, "_blank");
  }

  return (
    <S.Overlay>
      <CloseIcon className="close-icon" onClick={onCloseButtonClick} />

      <S.SelectedImageInfo>
        Imagem {selectedGalleryPictureIndex + 1} de {galleryLength}
      </S.SelectedImageInfo>

      {selectedGalleryPictureIndex > 0 && (
        <Arrow
          role="button"
          className="left-arrow"
          onClick={onLeftArrowClick}
        />
      )}

      <S.ModalPictureImage src={imgUrl} alt={imgAlt} />

      {selectedGalleryPictureIndex < galleryLength - 1 && (
        <Arrow
          role="button"
          className="right-arrow"
          onClick={onRightArrowClick}
        />
      )}

      <Download
        className="download-button"
        role="button"
        title="Baixar imagem"
        onClick={handleDownload}
      />

      <S.CoordinatesWrapper>
        {!coordinates && <p>Nenhuma coordenada associada a essa imagem!</p>}

        {coordinates && (
          <S.CoordinatesContainer>
            <p>Coordenadas da imagem:</p>
            <p>Latitude: {coordinates.lat}</p>
            <p>Longitude: {coordinates.lng}</p>
            <button onClick={() => handleCopyCoordinates(coordinates)}>
              Copiar
            </button>
          </S.CoordinatesContainer>
        )}
      </S.CoordinatesWrapper>
    </S.Overlay>
  );
}
